var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandidateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 13V11.6667C14.6663 10.4241 13.8165 9.38004 12.6663 9.08401M10.333 1.19384C11.3103 1.58943 11.9997 2.54754 11.9997 3.66667C11.9997 4.78579 11.3103 5.7439 10.333 6.13949M11.333 13C11.333 11.7575 11.333 11.1362 11.13 10.6462C10.8594 9.99277 10.3402 9.47364 9.68683 9.20299C9.19677 9 8.57552 9 7.33301 9H5.33301C4.0905 9 3.46924 9 2.97919 9.20299C2.32578 9.47364 1.80665 9.99277 1.536 10.6462C1.33301 11.1362 1.33301 11.7575 1.33301 13M8.99967 3.66667C8.99967 5.13943 7.80577 6.33333 6.33301 6.33333C4.86025 6.33333 3.66634 5.13943 3.66634 3.66667C3.66634 2.19391 4.86025 1 6.33301 1C7.80577 1 8.99967 2.19391 8.99967 3.66667Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateIcon);
export default __webpack_public_path__ + "static/media/candidateIcon.b300a8f14c1e186b9b62d50038ab807d.svg";
export { ForwardRef as ReactComponent };